<template>
  <div class="cart-confirmation">
    <div class="cart-confirmation-header">
      <h1 class="cart-title">{{ Translator('front.cart.confirmation.title') }}</h1>
    </div>
    <div class="cart-confirmation-container" :class="{'is-loading': !user || !cart }">
      <div v-if="user && cart">
        <template v-if="cart.shippingMethod.isWithTransporter">
          <i class="ico ico-check"></i>
          <p class="cart-confirmation-title">{{ Translator('front.cart.confirmation.with_transport.subtitle') }}</p>
          <p class="cart-confirmation-order">{{ Translator('front.cart.confirmation.with_transport.order', {'order_number': cart.id}) }}</p>
          <p class="cart-confirmation-description" v-html="Translator('front.cart.confirmation.with_transport.description', {'email': user.email, 'linkToNoticeInt': linkToNoticeIntl})"></p>
          <a :href="linkToNoticeFr" v-if="linkToNoticeFr" target="_blank" rel="noopener noreferrer" class="cart-confirmation-button">{{ Translator('front.cart.confirmation.with_transport.btn_guide') }}</a>
          <div class="cart-confirmation-links">
            <a :href="Routing('app_documents_orders_summary', {order: cart.id})" download class="cart-confirmation-link">{{ Translator('front.cart.confirmation.with_transport.btn_resume') }}</a>
          </div>
        </template>
        <template v-if="!cart.shippingMethod.isWithTransporter">
          <i class="ico ico-check"></i>
          <p class="cart-confirmation-title">{{ Translator('front.cart.confirmation.without_transport.subtitle') }}</p>
          <p class="cart-confirmation-order">{{ Translator('front.cart.confirmation.without_transport.order', {'order_number': cart.id}) }}</p>
          <p class="cart-confirmation-description" v-html="Translator('front.cart.confirmation.without_transport.description', {'email': user.email})"></p>
          <a :href="Translator('front.cart.confirmation.without_transport.link_rmp')" target="_blank" rel="noopener noreferrer" class="cart-confirmation-button">{{ Translator('front.cart.confirmation.without_transport.btn_recipe') }}</a>
          <div class="cart-confirmation-links">
            <a :href="Routing('app_documents_orders_summary', {order: cart.id})" download class="cart-confirmation-link">{{ Translator('front.cart.confirmation.without_transport.btn_resume') }}</a>
            <a :href="Routing('app_documents_orders_filing', {order: cart.id})" class="cart-confirmation-link">{{ Translator('front.cart.confirmation.without_transport.btn_notice') }}</a>
          </div>
        </template>
      </div>
    </div>
    <div class="confirmation-steps">
      <p class="confirmation-steps-title">{{ Translator('front.cart.confirmation.title_after') }}</p>

      <div class="confirmation-steps-container" v-if="cart.shippingMethod.isWithTransporter">
        <div class="confirmation-steps-element">
          <div class="confirmation-steps-content">
            <p class="confirmation-steps-number">1</p>
            <div class="confirmation-steps-media">
              <img src="/assets/default/images/impression-recapitulatif.svg" alt="">
            </div>
            <p class="confirmation-steps-description">{{ Translator('front.cart.confirmation.with_transport.steps.step0.title') }}</p>
          </div>
        </div>
        <div class="confirmation-steps-element">
          <div class="confirmation-steps-content">
            <p class="confirmation-steps-number">2</p>
            <div class="confirmation-steps-media">
              <img src="/assets/default/images/emballage-cartes-envoi-ccc.svg" alt="">
            </div>
            <p class="confirmation-steps-description">{{ Translator('front.cart.confirmation.with_transport.steps.step1.title') }}</p>
          </div>
        </div>
        <div class="confirmation-steps-element">
          <div class="confirmation-steps-content">
            <p class="confirmation-steps-number">3</p>
            <div class="confirmation-steps-media">
              <img src="/assets/default/images/envoi-cartes-pour-certification.svg" alt="">
            </div>
            <p class="confirmation-steps-description">{{ Translator('front.cart.confirmation.with_transport.steps.step2.title') }}</p>
            <p class="confirmation-steps-details" v-html="Translator('front.cart.confirmation.with_transport.steps.step2.description')"></p>
          </div>
        </div>
      </div>
      <div class="confirmation-steps-container" v-if="!cart.shippingMethod.isWithTransporter">
        <div class="confirmation-steps-element">
          <div class="confirmation-steps-content">
            <p class="confirmation-steps-number">1</p>
            <div class="confirmation-steps-media">
              <img src="/assets/default/images/impression-recapitulatif.svg" alt="">
            </div>
            <p class="confirmation-steps-description">{{ Translator('front.cart.confirmation.without_transport.steps.step0.title') }}</p>
          </div>
        </div>
        <div class="confirmation-steps-element">
          <div class="confirmation-steps-content">
            <p class="confirmation-steps-number">2</p>
            <div class="confirmation-steps-media">
              <img src="/assets/default/images/emballage-cartes-envoi-ccc.svg" alt="">
            </div>
            <p class="confirmation-steps-description">{{ Translator('front.cart.confirmation.without_transport.steps.step1.title') }}</p>
          </div>
        </div>
        <div class="confirmation-steps-element">
          <div class="confirmation-steps-content">
            <p class="confirmation-steps-number">3</p>
            <div class="confirmation-steps-media">
              <img src="/assets/default/images/envoi-cartes-pour-certification.svg" alt="">
            </div>
            <p class="confirmation-steps-description">{{ Translator('front.cart.confirmation.without_transport.steps.step2.title') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OrdersService from '@/services/Orders';
import UsersService from '@/services/Users';

export default {
  name: 'cart-confirmation',
  data () {
    return {
      linkToNoticeFr: window.config && window.config.linkToNoticeFr ? window.config.linkToNoticeFr : null,
      linkToNoticeIntl: window.config && window.config.linkToNoticeIntl ? window.config.linkToNoticeIntl : null,
      cart: OrdersService.cart,
      user: UsersService.datas
    }
  },
  created() {
    this._onUpdateCart = this._onUpdateCart.bind(this);
    this._onUpdateUser = this._onUpdateUser.bind(this);
  },
  beforeDestroy() {
    OrdersService.off('updated', this._onUpdateCart);
    UsersService.off('update', this._onUpdateUser);
  },
  mounted() {
    OrdersService.on('updated', this._onUpdateCart);
    UsersService.on('update', this._onUpdateUser);
    const event = new CustomEvent('cart:update', { detail: 0 });
    document.body.dispatchEvent(event);
  },
  methods: {
    _onUpdateCart(res) {
      this.cart = res;
    },
    _onUpdateUser(res) {
      this.user = res;
    },

    Routing(key, datas = null) {
      return window.Routing.generate(key, datas);
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
<style scoped lang="scss">
.cart-confirmation {
  &::before {
    @include fullSize;
    background: $gradient;
    z-index: -1;
    content: '';
    position: absolute;
    top: 0;
    height: 30vh;

    @include tablet {
      height: rem(610);
    }
  }
  .cart-confirmation-header {
    text-align: center;
    @include vertical-spacing-bottom;
  }
  .cart-title {
    @include title;
    color: $white;
    text-transform: uppercase;
  }
  .cart-confirmation-container {
    @include container;
    @include vertical-spacing-bottom;
    display: block;
    text-align: center;
    padding: rem(40) rem(30);
    min-height: rem(300);
    max-width: rem(900);
    margin-left: auto;
    margin-right: auto;
    width: 95%;
    .ico {
      color: $color-second;
      font-size: rem(140);
      margin-bottom: rem(10);
    }
    &.is-loading {
      @include loader;
    }
  }
  .cart-confirmation-title {
    @include title(4);
    margin-bottom: rem(20);
    color: $black;
  }
  .cart-confirmation-order {
    font-weight: bold;
    color: $black;
    margin-bottom: rem(20);
  }
  .cart-confirmation-description {
    margin-bottom: rem(25);
    line-height: 1.5;
  }
  .cart-confirmation-button {
    @include cta;
  }
  .cart-confirmation-links {
    margin-top: rem(50);
    width: 100%;
    @include tablet {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .cart-confirmation-link {
    display: inline-block;
    padding: rem(5) rem(10);
    text-decoration: underline;
    transition: color $transition-out-hover;
    @include mobile {
      width: 100%;
    }
    @include tablet {
      &:not(:first-child) {
        &::before {
          content: '|';
          margin-right: rem(15);
        }
      }
    }
    &:hover, &:focus {
      color: $color-second;
      transition: color $transition-in-hover;
    }
  }
}
.confirmation-steps {
  @include wrapper;
  @include vertical-spacing-bottom(2);
  .confirmation-steps-title {
    @include title(2);
    text-align: center;
  }
  .confirmation-steps-container {
    margin-left: rem(-15);
    margin-right: rem(-15);
    @include tablet {
      display: flex;
    }
  }
  .confirmation-steps-element {
    padding-left: rem(15);
    padding-right: rem(15);
    flex: 1 0 0;
    @include mobile {
      margin: rem(15);
    }
  }
  .confirmation-steps-content {
    @include container;
    padding: rem(30);
    text-align: center;
    height: 100%;
  }
  .confirmation-steps-number {
    width: rem(36);
    margin-left: auto;
    margin-right: auto;
    height: rem(36);
    line-height: rem(36);
    font-weight: bold;
    color: $white;
    border-radius: 100%;
    text-align: center;
    background: linear-gradient(to bottom, $blue-uudark, $blue-dark);
    margin-bottom: rem(10);
  }
  .confirmation-steps-media {
    width: rem(130);
    height: rem(100);
    margin-left: auto;
    margin-right: auto;
    position: relative;
    margin-bottom: rem(25);
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .confirmation-steps-description {
    font-weight: bold;
    color: $blue-udark;
  }
  .confirmation-steps-details {
    font-size: rem(14);
    margin-top: rem(20);
  }
}
</style>
